import "./Qualidade.scss";
import { desktopImages, mobileImages } from "../../images";
import BrandsCarousel from "./components/BrandsCarousel/BrandsCarousel";
import BrandsCarouselMobile from "./components/BrandsCarouselMobile/BrandsCarouselMobile";
import BrandsListMobile from "./components/BrandsListMobile/BrandsListMobile";
import QualidadeBanner from "./components/QualidadeBanner/QualidadeBanner";
import QualidadeBannerMobile from "./components/QualidadeBannerMobile/QualidadeBannerMobile";
import TestimonialsCarousel from "./components/TestimonialsCarousel/TestimonialsCarousel";
import { useState, useEffect } from "react";
import ReactPlayer from "react-player";

const Qualidade = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getImage = (name) =>
    isMobile ? mobileImages[name] : desktopImages[name];

  return (
    <div className="qualidade">
      {/* Hero Section with GIF Background */}
      <div className="hero-section">
        <video
          className="hero-video"
          autoPlay
          muted
          loop
          playsInline
          poster={getImage("QualidadeCabecalhoPoster")}
        >
          <source src={getImage("QualidadeCabecalho")} type="video/mp4" />
          {/* Fallback for browsers that don't support the video element */}
          Seu navegador não suporta o elemento de vídeo.
        </video>
        <div className="hero-overlay">
          <div className="hero-content">
            <h1 className="hero-title">
              No Essentia Group, <br />
              <em>qualidade</em> não é só um padrão. <br />
              É um <strong>princípio</strong>.
            </h1>
            <div className="hero-logo">
              <ReactPlayer
                url="https://www.youtube.com/embed/iAcFYEZ4ocw"
                playing
                loop
                controls
                // volume={1}
                width="758px"
                height="426px"
                className="anos-logo"
                config={{
                  youtube: {
                    playerVars: { autoplay: 1, mute: 1 }
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Second Block - Qualidade que se vive */}
      <div className="qualidade-block">
        <div className="container">
          <div className="block-header">
            <h2 className="block-title">
              <span className="title-bold">QUALIDADE</span><br />
              <span className="title-normal">QUE SE VIVE</span>
            </h2>
          </div>

          <div className="block-content">
            <div className="content-image">
              <img
                src={getImage("QualidadeQueSeVive")}
                alt="Qualidade que se vive"
                className="qualidade-image"
              />
            </div>
            <div className="content-text">
              <h3 className="text-highlight">
                Há 20 anos, a qualidade é o nosso ponto de partida.
              </h3>
              <p className="text-paragraph">
                No Essentia Group, a qualidade é mais do que uma etapa. É um princípio que orienta cada
                escolha, desde a pesquisa e o desenvolvimento até a experiência de quem confia em nossos
                produtos. É o reflexo do amor com que escolhemos fazer tudo o que fazemos.
              </p>
              <p className="text-paragraph">
                Com rigor técnico, inovação contínua e profundo respeito pelo ser humano, construímos um
                padrão que é percebido não apenas pelos resultados, mas pela confiança que ele inspira.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Third Block - Brands Carousel */}
      {!isMobile ? (
        <BrandsCarousel />
      ) : (
        <>
          <BrandsCarouselMobile />
          <BrandsListMobile />
        </>
      )}

      {/* Fourth Block - Qualidade Banner */}
      {!isMobile ? (
        <QualidadeBanner />
      ) : (
        <QualidadeBannerMobile />
      )}

      {/* Fifth Block - Testimonials Carousel */}
      <TestimonialsCarousel />


    </div>
  );
};

export default Qualidade;